module.exports = __webpack_public_path__ + "static/img/home_banner.96e49fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_banner.png
// module id = ILbt
// module chunks = 0